export default __webpack_public_path__ + "static/media/location-big.0040c0e8.png";